"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const header_keys_1 = require("../../../constants/header-keys");
const dateHelper_1 = require("../../../helper/dateHelper");
const typescriptHacks_1 = require("../../../helper/typescriptHacks");
const authHandler = (response, userVm, userAccFunc) => {
    const token = response.headers.get(header_keys_1.TokenHeaderKey);
    const tokenExpiry = response.headers.get(header_keys_1.TokenExpiryHeaderKey);
    const userGuid = response.headers.get(header_keys_1.UserGuidHeaderKey);
    userAccFunc({
        userGuid: userGuid,
        username: userVm.username,
        profilePic: userVm.profileUrl,
        token: token,
        tokenExpiry: tokenExpiry,
        tokenExpiryDate: (0, dateHelper_1.addSeconds)(new Date(), tokenExpiry),
    });
    return response.status == 200;
};
const accountController = (service) => ({
    loginWithGoogleAuth: (userVm, userAccFunc) => __awaiter(void 0, void 0, void 0, function* () {
        const isSuccess = yield service.post(endpoints_1.endpoints.authUrl, userVm, () => typescriptHacks_1.anyObject, (response) => authHandler(response, userVm, userAccFunc));
        return {
            isSuccess,
            errorMessage: '',
        };
    }),
    getFakeToken: (userAccFunc) => __awaiter(void 0, void 0, void 0, function* () {
        const fakeUserVm = {
            username: 'fake account',
            profileUrl: 'profile.png',
        };
        const isSuccess = yield service.post(endpoints_1.endpoints.fakeAuthUrl, typescriptHacks_1.anyObject, () => typescriptHacks_1.anyObject, (response) => authHandler(response, fakeUserVm, userAccFunc));
        return {
            isSuccess,
            errorMessage: '',
        };
    })
});
exports.accountController = accountController;
